import React from 'react'
import { AppProvider } from 'stores/AppStore'
import { UserProvider } from 'stores/UserStore'
import { ThemeProvider } from 'styled-components'
import { Analytics, Auth } from 'aws-amplify'
import API from '@aws-amplify/api'
import PubSub from '@aws-amplify/pubsub'
import { authConfig, appSyncConfig } from 'aws'
import theme from 'utils/theme'
import Router from 'Router'
import 'i18n'
import { toast, Slide } from 'react-toastify'

toast.configure({
  autoClose: 5000,
  draggable: false,
  transition: Slide,
  hideProgressBar: false,
  closeButton: false
})

Auth.configure(authConfig)
Analytics.configure({ disabled: true })
PubSub.configure(appSyncConfig)
API.configure(appSyncConfig)

const App = () => (
  <ThemeProvider theme={theme}>
    <AppProvider>
      <UserProvider>
          <Router />
      </UserProvider>
    </AppProvider>
  </ThemeProvider>
)

export default App
